import { render, staticRenderFns } from "./NewsModalPoster.vue?vue&type=template&id=1050c310&lang=pug&"
import script from "./NewsModalPoster.vue?vue&type=script&lang=js&"
export * from "./NewsModalPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports